var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import styled from 'styled-components';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import * as format from 'date-fns/format';
import * as cx from 'classnames';
import { MEDIA_QUERIES } from 'shared/style';
import { ROLE } from 'shared/types';
import Loading from 'components/shared/Loading';
import Error from 'components/shared/Error';
import CommentWriter from './CommentWriter';
import { GET_COMMENTS } from '.';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n\n  > .modify-mode  {\n    padding: 20px 0;\n    overflow: hidden;\n  }\n\n  > .header {\n    ", " {\n      height: 70px;\n      padding: 25px 20px;\n    }\n    ", " {\n      padding: 25px 5px;\n    }\n    \n    overflow: hidden;\n    font-size: 14px;\n    \n    > .left {\n        float: left;\n      \n      > span {\n        font-size: 16px;\n        line-height: 20px;\n        \n        &:not(:first-child) {\n          margin-left: 10px;\n        }\n      }\n\n      > .name {\n        font-weight: bold;\n      }\n\n      > .time {\n        color: #888;\n        font-size: 12px;\n      }\n\n      > .pc-tablet {\n        ", " {\n          display: none;\n        }\n      }\n\n      > .phone {\n        ", " {\n          display: none;\n        }\n      }\n\n      > .special {\n        color: #36c;\n      }\n    }\n\n    > .right {\n      float: right;\n\n      > span {\n        cursor: pointer;\n      }\n\n      > .modify {\n        color: #009;\n      }\n\n      > .delete {\n        margin-left: 10px;\n        color: #b00;\n      }\n    }\n  }\n\n  > .content {\n    ", " {\n      padding: 0 20px 30px;\n    }\n    ", " {\n      padding: 0 5px 30px;\n    }\n    font-size: 20px;\n  }\n"], ["\n  width: 100%;\n\n  > .modify-mode  {\n    padding: 20px 0;\n    overflow: hidden;\n  }\n\n  > .header {\n    ", " {\n      height: 70px;\n      padding: 25px 20px;\n    }\n    ", " {\n      padding: 25px 5px;\n    }\n    \n    overflow: hidden;\n    font-size: 14px;\n    \n    > .left {\n        float: left;\n      \n      > span {\n        font-size: 16px;\n        line-height: 20px;\n        \n        &:not(:first-child) {\n          margin-left: 10px;\n        }\n      }\n\n      > .name {\n        font-weight: bold;\n      }\n\n      > .time {\n        color: #888;\n        font-size: 12px;\n      }\n\n      > .pc-tablet {\n        ", " {\n          display: none;\n        }\n      }\n\n      > .phone {\n        ", " {\n          display: none;\n        }\n      }\n\n      > .special {\n        color: #36c;\n      }\n    }\n\n    > .right {\n      float: right;\n\n      > span {\n        cursor: pointer;\n      }\n\n      > .modify {\n        color: #009;\n      }\n\n      > .delete {\n        margin-left: 10px;\n        color: #b00;\n      }\n    }\n  }\n\n  > .content {\n    ", " {\n      padding: 0 20px 30px;\n    }\n    ", " {\n      padding: 0 5px 30px;\n    }\n    font-size: 20px;\n  }\n"])), MEDIA_QUERIES.PC_TABLET, MEDIA_QUERIES.PHONE, MEDIA_QUERIES.PHONE, MEDIA_QUERIES.PC_TABLET, MEDIA_QUERIES.PC_TABLET, MEDIA_QUERIES.PHONE);
var GET_USER = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  {\n    currentUser {\n      id\n      role\n    }\n  }\n"], ["\n  {\n    currentUser {\n      id\n      role\n    }\n  }\n"])));
var MODIFY_COMMENT = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  mutation ModifyComment($comment: ModifyingCommentPayload!) {\n    comment: modifyComment(comment: $comment) {\n      id\n      author {\n        id\n        name\n        role\n      }\n      createdAt\n      updatedAt\n      content\n    }\n  }\n"], ["\n  mutation ModifyComment($comment: ModifyingCommentPayload!) {\n    comment: modifyComment(comment: $comment) {\n      id\n      author {\n        id\n        name\n        role\n      }\n      createdAt\n      updatedAt\n      content\n    }\n  }\n"])));
var DELETE_COMMENT = gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  mutation DeleteComment($id: String!) {\n    comment: deleteComment(id: $id)\n  }\n"], ["\n  mutation DeleteComment($id: String!) {\n    comment: deleteComment(id: $id)\n  }\n"])));
var Comment = /** @class */ (function (_super) {
    __extends(Comment, _super);
    function Comment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isModifyMode: false
        };
        _this.modify = function (values, client) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, client.mutate({
                            mutation: MODIFY_COMMENT,
                            variables: {
                                comment: {
                                    content: values.content,
                                    id: this.props.comment.id,
                                }
                            },
                            update: function (cache, _a) {
                                var comment = _a.data.comment;
                                var comments = cache.readQuery({
                                    query: GET_COMMENTS,
                                    variables: { postId: values.post }
                                }).comments;
                                cache.writeQuery({
                                    query: GET_COMMENTS,
                                    variables: { postId: values.post },
                                    data: { comments: comments.map(function (orgComment) {
                                            return (orgComment.id !== comment.id) ? orgComment : comment;
                                        }) },
                                });
                                _this.setState({
                                    isModifyMode: false,
                                });
                            }
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.changeModifyMode = function (e, isModifyMode) {
            e.preventDefault();
            _this.setState({
                isModifyMode: isModifyMode,
            });
        };
        _this.delete = function (e, client) { return __awaiter(_this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                e.preventDefault();
                result = window.confirm('댓글을 삭제하시겠습니까?');
                if (result) {
                    client.mutate({
                        mutation: DELETE_COMMENT,
                        variables: {
                            id: this.props.comment.id,
                        },
                        update: function (cache) {
                            var comments = cache.readQuery({
                                query: GET_COMMENTS,
                                variables: { postId: _this.props.postId }
                            }).comments;
                            cache.writeQuery({
                                query: GET_COMMENTS,
                                variables: { postId: _this.props.postId },
                                data: { comments: comments.filter(function (comment) {
                                        return (comment.id !== _this.props.comment.id);
                                    }) },
                            });
                        }
                    });
                }
                return [2 /*return*/];
            });
        }); };
        return _this;
    }
    Comment.prototype.getTime = function (time, dateOnly) {
        if (dateOnly === void 0) { dateOnly = false; }
        var timeFormat = dateOnly
            ? 'YYYY-MM-DD'
            : 'YYYY-MM-DD A HH:mm:ss';
        return format(Number(time), timeFormat);
    };
    Comment.prototype.render = function () {
        var _this = this;
        var _a = this.props, comment = _a.comment, postId = _a.postId;
        var isModifyMode = this.state.isModifyMode;
        return (React.createElement(Query, { query: GET_USER }, function (_a) {
            var loading = _a.loading, error = _a.error, data = _a.data, client = _a.client;
            if (loading)
                return React.createElement(Loading, null);
            if (error)
                return React.createElement(Error, { error: error });
            var mutable = data.currentUser
                && ((data.currentUser.role <= ROLE.MANAGER)
                    || (comment.author.id === data.currentUser.id));
            return (React.createElement(Container, null, isModifyMode
                ? (React.createElement("div", { className: "modify-mode" },
                    React.createElement(CommentWriter, { postId: postId, submitButtonText: "\uC218\uC815", content: comment.content, onSubmit: _this.modify, onCancel: function (e) { return _this.changeModifyMode(e, false); } })))
                : (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "header" },
                        React.createElement("div", { className: "left" },
                            React.createElement("span", { className: cx('name', {
                                    special: comment.author.role <= ROLE.MANAGER
                                }) }, comment.author.name),
                            React.createElement("span", { className: "time pc-tablet" }, _this.getTime(comment.createdAt)),
                            comment.createdAt !== comment.updatedAt &&
                                React.createElement("span", { className: "time pc-tablet" },
                                    "(",
                                    _this.getTime(comment.updatedAt),
                                    " \uC5C5\uB370\uC774\uD2B8\uB428)"),
                            React.createElement("span", { className: "time phone" }, _this.getTime(comment.createdAt, true))),
                        mutable &&
                            React.createElement("div", { className: "right" },
                                React.createElement("span", { className: "modify", onClick: function (e) { return _this.changeModifyMode(e, true); } }, "\uC218\uC815"),
                                React.createElement("span", { className: "delete", onClick: function (e) { return _this.delete(e, client); } }, "\uC0AD\uC81C"))),
                    React.createElement("div", { className: "content" }, comment.content)))));
        }));
    };
    return Comment;
}(React.Component));
export default Comment;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
